import React, { useEffect, useState } from "react";
import ClaimSubmissionForm from "../../forms/Claim/ClaimSubmissionForm";
import PropTypes from "prop-types";
import { getClaim } from "../../../api/claimSubmissionApi";
import { getSignedAttachmentUrl } from "../../../api/attachApi";
import { toast } from "react-toastify";
import Axios from "axios";
import dayjs from "dayjs";
import { useTranslation } from "react-i18next";

const ClaimSubmissionPage = ({ history }) => {
  const { t } = useTranslation();
  const [isLoading, setIsLoading] = useState(true);
  const [claimDisplay, setClaimDisplay] = useState([]);
  const [currentYear, setCurrentYear] = useState(dayjs().year());
  const [pagination, setPagination] = useState({
    current: 1,
    minIndex: 0,
    maxIndex: 100,
    pageSize: 100,
  });

  useEffect(() => {
    setIsLoading(true);
    const CancelToken = Axios.CancelToken;
    const source = CancelToken.source();
    getClaim(source, currentYear)
      .then((result) => {
        // reset pagination
        resetPagination();

        setClaimDisplay(result);
        setIsLoading(false);
      })
      .catch((error) => {
        showErrorMessage(t("general.fail_to_load_record"), error);
      });
    return () => {
      source.cancel();
    };
  }, [currentYear, t]);

  function resetPagination() {
    setPagination({
      current: 1,
      minIndex: 0,
      maxIndex: 100,
      pageSize: 100,
    });
  }

  function onAddNewClaim() {
    history("/home/claimsubmission/claimTrans");
  }

  function viewClaimTrans(ClaimTransKey) {
    history("/home/claimsubmission/claimTrans/" + ClaimTransKey);
  }

  function getValidAttachments(attachments) {
    return getSignedAttachmentUrl(attachments);
  }

  function showErrorMessage(message, error) {
    let errorMsg = error.response.data.error_description
      ? error.response.data.error_description
      : error.response.data.ExceptionMessage;

    toast.error(message + (errorMsg ? errorMsg : ""));
  }

  return (
    <ClaimSubmissionForm
      isLoading={isLoading}
      data={claimDisplay}
      onAdd={onAddNewClaim}
      onView={viewClaimTrans}
      onAttachmentClicked={getValidAttachments}
      setCurrentYear={setCurrentYear}
      pagination={pagination}
      setPagination={setPagination}
      resetPagination={resetPagination}
    />
  );
};

ClaimSubmissionPage.propTypes = {
  history: PropTypes.func.isRequired,
};

export default ClaimSubmissionPage;
